import React from 'react';
import { ShieldCheck, Zap, Pencil } from 'lucide-react';

interface Props {
  name: string;
  code: string;
  active: boolean;
  featureCount: number;
  onChangePlan: (code: string) => void;
  onEdit: () => void;
  editing: boolean;
}

const SystemPlanHeader: React.FC<Props> = ({
  name,
  code,
  active,
  featureCount,
  onChangePlan,
  onEdit,
  editing,
}) => {
  return (
    <div className="flex items-center justify-between border-b border-stroke pb-4 dark:border-strokedark">

      {/* LEFT: info */}
      <div className="flex items-center gap-3">
        <div className="flex h-10 w-10 items-center justify-center rounded-md bg-primary/10 text-primary">
          <Zap size={18} />
        </div>

        <div>
          <h3 className="text-lg font-semibold text-black dark:text-white">
            {name}
          </h3>

          <p className="text-xs text-gray-500">
            Código: {code}
          </p>

          <p className="mt-0.5 text-xs text-primary">
            {featureCount} funcionalidades incluidas
          </p>
        </div>
      </div>

      {/* RIGHT: acciones */}
      <div className="flex items-center gap-2">

        {active && (
          <div className="flex items-center gap-2 text-sm font-medium text-green-600">
            <ShieldCheck size={16} />
            Plan activo
          </div>
        )}

        {!active && (
          <button
            onClick={() => onChangePlan(code)}
            className="
              inline-flex items-center gap-2
              rounded-sm bg-primary px-4 py-2 text-sm font-medium text-white
              shadow-sm hover:bg-opacity-90 transition
            "
          >
            Activar plan
          </button>
        )}

        {/* 🔥 Editar */}
        {!editing && (
          <button
            onClick={onEdit}
            className="
              inline-flex items-center gap-2
              rounded-sm border border-stroke
              bg-white px-3 py-2 text-sm font-medium
              text-black shadow-sm
              hover:bg-gray-2
              dark:border-strokedark dark:bg-boxdark dark:text-white dark:hover:bg-meta-4
              transition
            "
          >
            <Pencil size={14} />
            Editar
          </button>
        )}

      </div>
    </div>
  );
};

export default SystemPlanHeader;